<template>
    <div class="header-logo"
         @click="closeMobileMenu"
         @mouseover="hoverOn = true"
         @mouseleave="hoverOn = false">
        <router-link :to="{ path: '/' }"
                     class="logo-link-wrapper">
            <header-logo-svg :hover-on="hoverOn"  :width="width" />
        </router-link>
    </div>
</template>

<script>
    import _throttle from 'lodash/throttle'
    import HeaderLogoSvg from '../svgs/HeaderLogoSvg'

    export default {
        name: "HeaderLogo",
        components: { HeaderLogoSvg },
        data() {
            return {
                hoverOn: false,
                defaultWidth: 162,
                reduceLogoSize: false,
                mobileLogoSize: false
            }
        },
        created() {
            this._onResize = _throttle(this.onResize, 300);
            window.addEventListener('resize', this._onResize);
            this._onResize();``
        },
        computed: {
            width() {
                if (this.mobileLogoSize) {
                    return 120
                }
                return this.reduceLogoSize ? 142:this.defaultWidth
            }
        },
        methods: {
            onResize() {
                this.reduceLogoSize = window.innerWidth < 1230
                this.mobileLogoSize = window.innerWidth < 400
            },
            closeMobileMenu() {
                this.hoverOn = false;
                this.$emit('closeMobileMenu')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .header-logo {
        z-index: 999;
        margin-right: auto;
        height: 28px;

        .logo {
            width: 100%;
            margin: 0 auto;
        }

        @media (max-width: 400px) {
            margin-left: 5px;
        }
    }
</style>